export default "__VITE_ASSET__BKIPno2b__"